export const routes = {
  AIR_PORT: '/cargo/airport/',
  HANDLING_SERVICES_COST: '/cargo/handling-service-cost',
  ORIGIN_DESTINATION: '/cargo/OriginDestination',
  AWB_ISSUER_HISTORY: '/cargo/IssuedAWB/history',
  AJANS: '/cargo/IssuerAWB',
  ROUTE: '/cargo/route',
  CARGO_COST: '/cargo/cargocost/',
  AWB_NEW: '/cargo/awb_n/',
  AWB: '/cargo/awb',
  ISSUED_AWB: '/cargo/IssuedList',
  CCA_AWB_LIST: '/cargo/ccaList',
  DRAFT_AWB_LIST: '/cargo/draftList',
  TEMPORARY_AWB_LIST: '/cargo/temporaryList',
  RESERVED_AWB: '/cargo/ReserveAWB',
  AWB_LIST: '/cargo/awb_list',
  AWB_ISSUER: '/cargo/awb',
  SUBMIT_RECIEPT: '/cargo/awb?StatusID=4',
  DASHBOARD: '/cargo/dashboard',
  APPROVED_RECIEPT: '/cargo/ApprovedReceipt',
  USERS: '/cargo/users',
  ROLES: '/cargo/role',
  LEVELS: '/cargo/levels',
  REFUND: '/cargo/Refund',
  RECEIPT_HISTORY: '/cargo/SubmitReceipt/history',
  FORBIDDEN: '/cargo/Forbidden',
  CREATE_AWB: '/cargo/createAwb',
  EDIT_AWB: '/cargo/editAwb',
  EDIT_FILES_AWB: '/cargo/editFilesAwb',
  CCA_AWB: '/cargo/CcaAwb',
  EDIT_DRAFT_AWB: '/cargo/EditDraftAWB',
  EDIT_TEMPORARY_AWB: '/cargo/EditTemporaryAWB',
  TRANSACTIONS: '/cargo/Transaction',
  RETURN_MONEY: '/cargo/ReturnMoney',
  SIGN_IN: '/signin',
  FORGET_PASSWORD: '/forget-password',
  REPORTS: '/cargo/report',
  VOID_CONFIRMATION: '/cargo/VoidConfirmation',
  AWB_LISTS: '/cargo/AwbList/:formType?',
};

export default routes;
